export default __webpack_public_path__ + "static/media/tatanexoncar.555fc59013124bcc700a2cbf35cf4d86.png";